
import React from 'react';
import { BookingForm } from '@/components/booking/BookingForm';

const ConsultationContactForm: React.FC = () => {
  return (
    <section id="contact" className="section-padding bg-itmgmt-light-gray">
      <div className="container-wide">
        <div className="text-center mb-12">
          <h2 className="heading-lg text-itmgmt-dark-blue mb-4">Get in Touch</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Ready to elevate your business technology? Fill out the form below to book a consultation 
            with our experts and discover how we can help your organization thrive.
          </p>
        </div>
        
        <div className="bg-white rounded-lg shadow-md p-8 border border-gray-100 max-w-4xl mx-auto">
          <BookingForm isResidential={false} />
        </div>
      </div>
    </section>
  );
};

export default ConsultationContactForm;
